export default __webpack_public_path__ + "static/media/spiderToasty.b42fa0f6.png";